import React from 'react'
import ContentfulEngine from '../contentful-engine/engine';
import Cookies from "js-cookie";

const credentials = {
  'space': 'h7vzq2rtwdqn',
  'production': '8d82f2d4e26045b78c65e9c8f7ea0120ba23d4ae4edf8d06da6cd9b8fb76b408',
  'preview': '6312b88b988f0b05886906a0f9b71650908722c5bd66dd39c93a8ce2a186cb5a',
  'previewMode': true
}

export default class Base extends React.Component {
  engine = new ContentfulEngine(credentials);

  componentDidMount () {
    if (this.props.pathContext.page) {
      let { type, id, language } = this.props.pathContext.page;

      this.engine.getSingle(type, id, language).then(page => {
        this.refreshedPage = page[0];
        this.forceUpdate();
      });
    }

    if (this.props.pathContext?.language) {
      Cookies.set('nf_lang', this.props.pathContext.language);
    }

    window.engine = this.engine;
  }

  get content () {
    if (this.refreshedPage) {
      Object.assign(this.props.pathContext.page, this.refreshedPage);
    };
    return this.props.pathContext;
  }

  get image () {
    var header = this.content.page?.modules?.find(_ => _.type === 'modulePageHeader');
    if (header && header.images?.length > 0) {
      return header.images[0].image?.file?.url;
    }
    return false;
  }
}
